import policiesQuotesActions from '../actions/policiesQuotes.actions';

const policiesQuotesReducer = (state, action) => {
  switch (action.type) {
    case policiesQuotesActions.POLICIES_QUOTES_FILTER_CHANGE_SUCCESS:
      return Object.assign({}, state, {
        policies: action.policies,
        quotes: action.quotes,
      });
    case policiesQuotesActions.POLICIES_QUOTES_VIEW_DETAILS_REQUEST:
      return Object.assign({}, state, {
        id: action.id,
        policy: action.policy,
      });
    case policiesQuotesActions.POLICIES_QUOTES_BIND_REQUEST_SENT:
      return Object.assign({}, state, {
        bindRequestSent: action.bindRequestSent,
      });
    default:
      return state;
  }
};

export default policiesQuotesReducer;
